import type { ViewProps } from 'react-native'
import { Icon } from '~/components/icon'
import { Tag } from '~/components/tag'
import { useTheme } from '~/hooks'
import * as S from './benefitTag.styles'

type BaseProps = Omit<ViewProps, 'style'>

type BenefitTagProps =
  | ({ type: 'lmpm' } & BaseProps)
  | ({ type: 'ofex' } & BaseProps)
  | ({ type: 'univers'; value: string } & BaseProps)
  | ({ type: 'discount-lab' } & BaseProps)
  | ({ type: 'subscription'; value: string } & BaseProps)
  | ({ type: 'stix-trade' } & BaseProps)
  | ({ type: 'stix-earn-more' } & BaseProps)

const BenefitTag = (props: BenefitTagProps) => {
  const { type, ...rest } = props
  const theme = useTheme()

  if (type !== 'stix-earn-more' && type !== 'stix-trade') {
    const RENDER_BENEFIT_TITLE = {
      lmpm: 'Leve + pague -',
      ofex: 'Suas ofertas',
      univers: 'Univers',
      'discount-lab': 'Desc. Laboratório',
      subscription: 'Compra programada',
    }
    const renderValue =
      type === 'univers' || type === 'subscription' ? props.value : ''

    return (
      <S.Container {...rest}>
        {type !== 'subscription' ? (
          <Icon
            size="tiny"
            symbol="rdicon-tag-percentage"
            color="colorTextSuccessAlternative"
          />
        ) : null}
        <S.Title
          numberOfLines={1}
          style={[
            {
              color:
                type === 'subscription'
                  ? theme.colorActionTextOnbrandDefault
                  : theme.colorTextSuccessAlternative,
            },
            type !== 'subscription' && {
              paddingLeft: theme.spacingStackOnepulse,
            },
          ]}
        >
          {`${RENDER_BENEFIT_TITLE[type]} ${renderValue}`}
        </S.Title>
      </S.Container>
    )
  }

  return (
    <S.Container {...rest}>
      <Tag.Root
        variant={type === 'stix-earn-more' ? 'ganhe-stix' : 'trocar-stix'}
      >
        <Tag.Label>
          {type === 'stix-earn-more' ? 'Ganhe mais stix' : 'Trocar com stix'}
        </Tag.Label>
      </Tag.Root>
    </S.Container>
  )
}

export { BenefitTag }
